<div class="space-y-4">
  <div>
    <h2 class="text-lg font-bold text-[#1E2A78]">
      {{ 'DISB_SUMMARY.TITLE' | translate }}
    </h2>

    <p class="mt-1 text-sm text-slate-500">
      {{ 'DISB_SUMMARY.SUBTITLE' | translate }}
    </p>
  </div>

  @if (errorMessage) {
    <div
      class="rounded-xl border border-red-200 bg-red-50 p-4 text-sm font-medium text-red-700"
    >
      {{ errorMessage }}
    </div>
  }

  @if (loading) {
    <div
      class="rounded-xl border border-indigo-100 bg-indigo-50 p-6 text-center text-sm font-medium text-indigo-700"
    >
      {{ 'DISB_SUMMARY.LOADING_PLAN' | translate }}
    </div>
  }

  @if (!loading && rows.length === 0 && !errorMessage) {
    <div
      class="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center"
    >
      <h3 class="font-semibold text-slate-800">
        {{ 'DISB_SUMMARY.NO_SAVED_PLAN' | translate }}
      </h3>

      <p class="mt-2 text-sm text-slate-500">
        {{ 'DISB_SUMMARY.CALCULATE_AND_SAVE_FIRST' | translate }}
      </p>
    </div>
  }

  @if (!loading && rows.length > 0) {
    @for (group of groups; track group.rpymntTerm) {
    <h3 class="text-base font-semibold text-[#1E2A78]">
      {{ group.termName }}
    </h3>

    <div
      class="overflow-hidden rounded-xl border border-slate-300 bg-white shadow-sm"
    >
      <div
        class="border-b border-slate-300 bg-[#1E2A78] px-4 py-3 text-center text-sm font-bold text-white"
      >
        {{ 'DISB_SUMMARY.TABLE_TITLE' | translate }}
      </div>

      <div class="overflow-x-auto">
        <table
          class="w-full min-w-[1100px] border-collapse text-sm"
        >
          <thead>
            <tr class="bg-white">
              <th
                class="border border-slate-400 px-3 py-3 text-center font-bold text-slate-900"
              >
                {{ 'DISB_REPAYMENT.MONTH' | translate }}
              </th>

              <th
                class="border border-slate-400 px-3 py-3 text-center font-bold text-slate-900"
              >
                {{ 'DISB_REPAYMENT.PROPOSED_DISBURSEMENTS' | translate }}
              </th>

              <th
                class="border border-slate-400 px-3 py-3 text-center font-bold text-slate-900"
              >
                {{ 'DISB_REPAYMENT.PROPOSED_REPAYMENTS' | translate }}
              </th>

              <th
                class="border border-slate-400 px-3 py-3 text-center font-bold text-slate-900"
              >
                {{ 'DISB_SUMMARY.SCHEDULED_DISBURSEMENTS' | translate }}<br />
                <span class="text-xs">
                  ({{ 'DISB_SUMMARY.EXISTING_AGREEMENTS' | translate }})
                </span>
              </th>

              <th
                class="border border-slate-400 px-3 py-3 text-center font-bold text-slate-900"
              >
                {{ 'DISB_SUMMARY.SCHEDULED_REPAYMENTS' | translate }}<br />
                <span class="text-xs">
                  ({{ 'DISB_SUMMARY.EXISTING_AGREEMENTS' | translate }})
                </span>
              </th>

              <th
                class="border border-slate-400 px-3 py-3 text-center font-bold text-slate-900"
              >
                {{ 'DISB_SUMMARY.MAX_EXPOSURE_ANY_TIME' | translate }}
              </th>
            </tr>
          </thead>

          <tbody>
            @for (row of group.rows; track trackByMonth($index, row)) {
              <tr class="transition hover:bg-indigo-50/50">
                <td
                  class="border border-slate-400 px-3 py-2 font-semibold text-slate-800"
                >
                  {{ formatMonth(row.month) }}
                </td>

                <td
                  class="border border-slate-400 px-3 py-2 text-end text-slate-800"
                >
                  @if (row.proposedDisbursement > 0) {
                    <span>
                      {{
                        row.proposedDisbursement
                          | number: '1.0-2'
                      }}
                    </span>
                  } @else {
                    <span class="text-slate-300">-</span>
                  }
                </td>

                <td
                  class="border border-slate-400 px-3 py-2 text-end text-slate-800"
                >
                  @if (row.proposedRepayment > 0) {
                    <span>
                      {{
                        row.proposedRepayment
                          | number: '1.0-2'
                      }}
                    </span>
                  } @else {
                    <span class="text-slate-300">-</span>
                  }
                </td>

                <td
                  class="border border-slate-400 px-3 py-2 text-end text-slate-800"
                >
                  @if (row.scheduledDisbursement > 0) {
                    <span>
                      {{
                        row.scheduledDisbursement
                          | number: '1.0-2'
                      }}
                    </span>
                  } @else {
                    <span class="text-slate-300">-</span>
                  }
                </td>

                <td
                  class="border border-slate-400 px-3 py-2 text-end text-slate-800"
                >
                  @if (row.scheduledRepayment > 0) {
                    <span>
                      {{
                        row.scheduledRepayment
                          | number: '1.0-2'
                      }}
                    </span>
                  } @else {
                    <span class="text-slate-300">-</span>
                  }
                </td>

                <td
                  class="border border-slate-400 px-3 py-2 text-end font-semibold text-slate-900"
                >
                  {{
                    row.maximumExposure
                      | number: '1.0-2'
                  }}
                </td>
              </tr>
            }

            <tr class="bg-[#1E2A78] text-white">
              <td
                class="border border-indigo-300 px-3 py-3 font-bold"
              >
                {{ 'COMMON.TOTAL' | translate }}
              </td>

              <td
                class="border border-indigo-300 px-3 py-3 text-end font-bold"
              >
                {{
                  groupTotal(group, 'proposedDisbursement')
                    | number: '1.0-2'
                }}
              </td>

              <td
                class="border border-indigo-300 px-3 py-3 text-end font-bold"
              >
                {{
                  groupTotal(group, 'proposedRepayment')
                    | number: '1.0-2'
                }}
              </td>

              <td
                class="border border-indigo-300 px-3 py-3 text-end font-bold"
              >
                {{
                  groupTotal(group, 'scheduledDisbursement')
                    | number: '1.0-2'
                }}
              </td>

              <td
                class="border border-indigo-300 px-3 py-3 text-end font-bold"
              >
                {{
                  groupTotal(group, 'scheduledRepayment')
                    | number: '1.0-2'
                }}
              </td>

              <td
                class="border border-indigo-300 px-3 py-3"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  }
  }
</div>
